// Lightweight analytics helpers. Pushes events to window.dataLayer (GTM),
// window.gtag (GA4) and PostHog — all no-ops if the platform isn't loaded.

function getDataLayer() {
  if (typeof window === "undefined") return null;
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
}

export function track(event, payload = {}) {
  try {
    const dl = getDataLayer();
    if (dl) dl.push({ event, ...payload });
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", event, payload);
    }
    if (typeof window !== "undefined" && window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(event, payload);
    }
  } catch (e) {
    // Analytics must NEVER break the app — swallow all errors.
    // (GTM/posthog scripts can be blocked by ad-blockers; that's expected.)
    if (typeof window !== "undefined" && window.console && window.console.debug) {
      window.console.debug("[track] suppressed analytics error", event, e);
    }
  }
}

export const trackFormSubmit = (form, payload = {}) => track("form_submit", { form, ...payload });
export const trackPostcodeSearch = (payload) => track("postcode_search", payload);
export const trackPhoneClick = (number = "1300 380 692", surface = "site") =>
  track("phone_click", { number, surface });
export const trackPortalSignup = (payload = {}) => track("portal_signup", payload);
export const trackChatbotLead = (payload = {}) => track("chatbot_lead", payload);
